import React, { useRef } from "react";

import { Row, Col } from "react-bootstrap";
import { Draggable } from "react-beautiful-dnd";

import { useTopicCategoryContext } from "../../../contexts/TopicCategoryContext";

import editIcon from "images/icons/invite/edit.svg";
import deleteIcon from "images/icons/invite/delete.svg";

export default function TableItem({ category, index }) {
  const { dispatch, actions, state } = useTopicCategoryContext();

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    opacity: isDragging ? 0.5 : 1,
    ...draggableStyle,
  });

  const editTopicCategory = () => {
    actions.showEditForm(dispatch, category);
  };

  const deleteTopicCategory = (e) => {
    swal(
      {
        title: "",
        text: "Do you want to delete this topic category?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== "A") {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.deleteTopicCategory(dispatch, category.id, function () {
            actions.loadTopicCategories(dispatch);
          });
        }
      }
    );
  };

  return (
    <Draggable draggableId={category.id} index={index}>
      {(provided, snapshot) => (
        <li
          className="list-group-item"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style
          )}
        >
          <Row>
            <Col md={6}>
              <i className="fa fa-bars mr10"></i>
              {category.attributes.title}
            </Col>
            <Col md={2}>{category.attributes.category_type_name}</Col>
            <Col md={2}>{category.attributes.count_topics}</Col>
            <Col md={2} className="text-right">
              <a onClick={editTopicCategory} className="mr10">
                <img src={editIcon} />
              </a>
              <a onClick={(e) => deleteTopicCategory(e)}>
                <img src={deleteIcon} />
              </a>
            </Col>
          </Row>
        </li>
      )}
    </Draggable>
  );
}
